import { inject, Pipe, PipeTransform } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';

import { DeclensionPipe } from './declension.pipe';

@Pipe({ name: 'userAge' })
export class UserAgePipe implements PipeTransform {
    private declension = inject(DeclensionPipe);
    private i18next = inject(I18NextPipe);

    private config = [
        this.i18next.transform('general:year'),
        this.i18next.transform('general:years'),
        this.i18next.transform('general:year_one'),
    ];

    public transform(value: Date) {
        const result = Math.floor(moment().diff(value, 'years', true));

        return this.declension.transform(result, this.config);
    }
}
